var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoRecommendedChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75499 7.16H1.46699L0.259995 0.472H6.75499V7.16Z",
    fill: "#FEDC5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.182 5.763C15.181 6.582 14.519 7.246 13.7 7.25H9.433C8.614 7.246 7.952 6.582 7.951 5.763V1.495C7.953 0.677002 8.615 0.0150016 9.433 0.0110016H13.7C14.518 0.0140016 15.18 0.677002 15.182 1.495V5.763V5.763Z",
    fill: "#FFC643"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.467 15.283H6.755V8.527H1.467V15.283Z",
    fill: "#F04E3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.182 14.041C15.18 14.859 14.518 15.521 13.7 15.524H9.433C8.615 15.521 7.953 14.859 7.951 14.041V9.771C7.952 8.953 8.614 8.29 9.433 8.287H13.7C14.519 8.29 15.181 8.953 15.182 9.772V14.042V14.041Z",
    fill: "#DA2E32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75499 23.339H0.259995L1.46699 16.652H6.75499V23.339Z",
    fill: "#51A5CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.376 7.16H21.665L22.872 0.472H16.376V7.16Z",
    fill: "#EDA543"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.376 15.283H21.665V8.527H16.376V15.283Z",
    fill: "#902425"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.376 23.339H22.872L21.665 16.652H16.376V23.339Z",
    fill: "#1E6D99"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.182 22.322C15.18 23.14 14.518 23.803 13.7 23.806H9.433C8.615 23.803 7.953 23.14 7.951 22.322V18.046C7.955 17.23 8.617 16.57 9.433 16.566H13.7C14.518 16.57 15.18 17.233 15.182 18.051V22.322Z",
    fill: "#1D7BB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRecommendedChoice);
export default __webpack_public_path__ + "static/media/logo_recommended_choice.f1c3695f1f43a0a47103c6496551c20c.svg";
export { ForwardRef as ReactComponent };